// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"qK","controlPlay":"qL","controlElement":"qM","lowerControlWrapper":"qN","lowerControlIconWrapper":"qO","lowerControlIcon":"qP","show":"qQ"};